import React, { Component } from 'react';

import classNames from 'classnames';
import Select from 'components/cosmos/select';
import TooltipPortal from 'components/tooltip/TooltipPortal';
import PropTypes from 'prop-types';

import { I18n } from '../../translate';

import './CanvasMenuSelect.scss';

export default class CanvasMenuSelect extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.number,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    toolTip: PropTypes.string,
    toolTipId: PropTypes.string
  };

  static defaultProps = {
    label: '',
    active: false,
    toolTip: '',
    icon: ''
  };

  state = {
    showToolTip: true
  };

  async onChange(e) {
    const { onChange } = this.props;

    this.showToolTip();
    await onChange(e);
    this.showToolTip(true);
  }

  showToolTip(active = false) {
    this.setState({ showToolTip: active });
  }

  render() {
    const { options, value, placeholder, className, toolTip, toolTipId } =
      this.props;
    const { showToolTip } = this.state;
    const selectClasses = classNames('canvas-menu__select', '_mb-0', className);
    const tooltipId = toolTipId || Math.random();

    return (
      <div id={`canvas-menu-select__${tooltipId}`} className={className}>
        {toolTip && showToolTip && (
          <TooltipPortal parentId={`canvas-menu-select__${tooltipId}`}>
            <I18n label={toolTip} />
          </TooltipPortal>
        )}
        <Select
          id="classes"
          onChange={this.onChange.bind(this)}
          options={options}
          value={value}
          placeholder={placeholder}
          className={selectClasses}
        />
      </div>
    );
  }
}
